/* eslint-disable react-hooks/exhaustive-deps */
import React, { ReactNode, useEffect, useState } from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Grid,
  InputAdornment,
  TextField,
  LinearProgress,
  Typography,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { FleetDashboardOverviewApi } from "../../../../API/Iot-Api/FleetDashboardOverview/FleetDashobardOverview";
import {
  AllFleetListDailySummaryResponse,
  AllFleetListDailySummaryResponseDownload,
} from "../../../../@Types/DRO/IotApiResponse/FleetOverviewResponse";
import "./style.css";
import { CSVLink } from "react-csv";
import { blue } from "@mui/material/colors";

const FleetDailyReport = () => {
  const [searchValInput, setSearchValInput] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [downloadpage, setDownloadPage] = useState(1);
  const [downloadrowsPerPage, setDownloadRowsPerPage] = useState(50000);
  const [totalCount, setTotalCount] = useState<any>();
  const [selectedDate, setSelectedDate] = useState<any>();
  const [userRole, setUserRole] = useState<string | null>(null);
  
  const [fleetDailySummary, setFleetDailySummary] =
    useState<AllFleetListDailySummaryResponse | null>(null);
  const [fleetDailySummaryDownload, setFleetDailySummaryDownload] =
    useState<AllFleetListDailySummaryResponseDownload | null>(null);

  const pageRange = 5;
useEffect(()=>{
    const role = localStorage.getItem("authority");
    setUserRole(role);
  },[])

  const tableHeaderCellStyle = {
    fontWeight: 600,
    fontSize: "14px",
    color: "#455A64",
    font: "Rubik",
  };
  const tableBodyCellStyle = {
    fontWeight: 400,
    fontSize: "14px",
    color: "#A4A2A2",
    font: "Rubik",
  };
  // Dummy data for tables

  const pageCount = Math.ceil(totalCount / rowsPerPage);
  const handlePageChange = (newPage: number) => {
    const newPageNumber = Math.max(1, Math.min(newPage + 1, pageCount));
    setPage(newPageNumber - 1);
  };

  const formatTime = (dateTime: string) => {
    const formattedDateTime = dateTime.replace("T", " "); // Replace "T" with a space
    const date = new Date(formattedDateTime); // Convert to Date object
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0"); // Format hours to 2 digits
    const minutes = String(date.getMinutes()).padStart(2, "0"); // Format minutes to 2 digits
    const seconds = String(date.getSeconds()).padStart(2, "0"); // Format seconds to 2 digits

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // Return date and time in YYYY-MM-DD HH:MM:SS format
  };
  const formatCoordinates = (location: string) => {
    return location
      .split(",")
      .map((coord: string) => parseFloat(coord).toFixed(6))
      .join(",");
  };

  const renderPageNumbers = () => {
    const pagesToShow = Math.min(pageCount, pageRange);
    const startPage = Math.max(
      0,
      Math.min(page - Math.floor(pageRange / 2), pageCount - pagesToShow)
    );

    return Array.from({ length: pagesToShow }, (_, index) => {
      const pageNumber = startPage + index + 1;
      return (
        <span
          key={index}
          onClick={() => handlePageChange(pageNumber - 1)}
          className={page === pageNumber - 1 ? "active" : "unactive"}
          style={{ marginLeft: "6px" }}
        >
          {pageNumber}
        </span>
      );
    });
  };
  const handleClearSearch = () => {
    setSearchValInput("");
  };
  useEffect(() => {
    //const searcValue = `${searchValInput ? `?search=${searchValInput}` : ""}`;
    const fetchFleetDailySummary = async () => {
      try {
        const data: AllFleetListDailySummaryResponse =
          await FleetDashboardOverviewApi.api.getAllFleetDailySummary(
            searchValInput,
            page + 1,
            rowsPerPage,
            selectedDate
          );

        setFleetDailySummary(data);
        setTotalCount(data.data.total_count);
      } catch (error) {
        console.error("Error fetching fleet summary", error);
      }
    };
    fetchFleetDailySummary();
  }, [searchValInput, page, selectedDate]);

  useEffect(() => {
    const fetchFleetDailySummaryDownload = async () => {
      try {
        const data: AllFleetListDailySummaryResponseDownload =
          await FleetDashboardOverviewApi.api.getAllFleetDailySummaryDownload(
            selectedDate,
            downloadpage,
            downloadrowsPerPage
          );

        setFleetDailySummaryDownload(data);
      } catch (error) {
        console.error("Error fetching fleet summary for download", error);
      }
    };
    fetchFleetDailySummaryDownload();
  }, [selectedDate, downloadpage, downloadrowsPerPage]);

  const fleetDailySummaryButton = [
    { label: "Vehicle No.", key: "QrCode" },
    { label: "Fleet Model", key: "fleet_name" },
    { label: "Start Time", key: "Start_Time" },
    { label: "End Time", key: "end_time" },
    { label: "Distance", key: "iot_distance" },
    { label: "Start SoC", key: "start_soc" },
    { label: "End SoC", key: "end_soc" },
    { label: "Avg. Speed", key: "Average_Speed" },
    { label: "Start Location", key: "start_location" },
    { label: "End Location", key: "end_location" },
  ];
  return (
    <div className="w-full flex bg-white min-h-80 shadow-lg p-3 rounded-xl">
      <div className="w-full">
        <Grid container spacing={5} className="w-full flex justify-between ">
          <Grid item md={3}>
            <div className="flex ml-4">
              <h2 className="text-center ml-2 mx-1 mt-2 font-bold text-base text-black pb-2">
                Fleet Daily Summary Report{" "}
              </h2>
            </div>
          </Grid>
          <Grid item md={9}>
            <div className="flex mr-4">
              <div className="flex w-full justify-end">
                <div className="mr-3">
                  <TextField
                    placeholder="Search  EB Number"
                    id="outlined-basic"
                    variant="outlined"
                    onChange={(search: any) =>
                      setSearchValInput(search.target.value)
                    }
                    value={searchValInput}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment
                          position="end"
                          onClick={handleClearSearch}
                        >
                          <ClearIcon style={{ cursor: "pointer" }} />
                        </InputAdornment>
                      ),
                      style: { height: "40px", borderRadius: "25px" },
                    }}
                    // onKeyDown={handleKeyPress}
                  />
                </div>

                <div>
                  <TextField
                    name="fdate"
                    id="fdate"
                    //label="Select Date"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      style: { height: "40px", borderRadius: "15px" },
                    }}
                    required
                    //sx={{ mr: 2, width: 300, height: 30, mb: 3 }}
                    onChange={(date) => {
                      setSelectedDate(date.target.value);
                    }}
                  />
                </div>
                <div>
  {(userRole === "ROLE_FLEET_SUPER_ADMIN" || 
    userRole === "ROLE_ADMIN" || 
    userRole === "ROLE_CO_ADMIN") && ( // Ensure this condition is checked
    <CSVLink
      data={
        searchValInput
          ? fleetDailySummary?.data?.fleet_summary_data || [] // Use filtered data if filters are applied
          : fleetDailySummaryDownload?.data?.fleet_summary_data || [] // Default to the full download dataset
      }
      headers={fleetDailySummaryButton}
      filename={`Fleet_Daily_Summary_Report.csv`}
      style={{ marginRight: "10px" }}
    >
      <Button
        style={{
          backgroundColor: "#06B681",
          padding: "8px 20px",
          color: "#fff",
          borderRadius: "25px",
          width: "100%",
          textTransform: "none",
          marginLeft: "10px",
        }}
      >
        Download
      </Button>
    </CSVLink>
  )}
</div>

              </div>
            </div>
          </Grid>
        </Grid>
        <hr className="my-4" />

        <TableContainer>
          {!fleetDailySummary ? ( // Check if API response is still undefined (loading)
            <LinearProgress />
          ) : typeof fleetDailySummary.data === "string" ? ( // If API returns "No Data Found" as a string
            <Typography style={{ textAlign: "center", padding: "10px" }}>
              No data available
            </Typography>
          ) : fleetDailySummary.data.fleet_summary_data.length === 0 ? ( // If the array is empty
            <Typography style={{ textAlign: "center", padding: "10px" }}>
              No data available
            </Typography>
          ) : (
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 120 }}
                  >
                    Vehicle No.
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 150 }}
                  >
                    Fleet Model
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 110 }}
                  >
                    Start Time
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 110 }}
                  >
                    End Time
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    Distance (Km)
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    Start SoC
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 100 }}
                  >
                    End SoC
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 110 }}
                  >
                    Avg. Speed
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 130 }}
                  >
                    Start Location
                  </TableCell>
                  <TableCell
                    style={{ ...tableHeaderCellStyle, textAlign: "center" }}
                    sx={{ minWidth: 130 }}
                  >
                    End Location
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {fleetDailySummary.data.fleet_summary_data.map(
                  (item: any, index: any) => (
                    <TableRow key={index}>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.QrCode}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.fleet_name}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {formatTime(item.Start_Time)}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {formatTime(item.end_time)}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.iot_distance}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.start_soc}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.end_soc}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        {item.Average_Speed}
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        <a
                          style={{ color: blue[400] }}
                          href={`https://www.google.com/maps?q=${item.start_location}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {formatCoordinates(item.start_location)}
                        </a>
                      </TableCell>
                      <TableCell
                        style={{ ...tableBodyCellStyle, textAlign: "center" }}
                      >
                        <a
                          style={{ color: blue[400] }}
                          href={`https://www.google.com/maps?q=${item.end_location}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {formatCoordinates(item.end_location)}
                        </a>
                      </TableCell>
                    </TableRow>
                  )
                )}
              </TableBody>
            </Table>
          )}
        </TableContainer>

        <div className="pl-2 pt-4 pb-2 pr-16">
          <div
            className="pagination"
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <div>
              <button
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 0}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginRight: "6px",
                }}
              >
                {"<"}
              </button>
              {renderPageNumbers()}
              <button
                onClick={() => handlePageChange(page + 1)}
                disabled={page >= pageCount - 1}
                style={{
                  fontFamily: "Rubik",
                  fontSize: "20px",
                  marginLeft: "6px",
                }}
              >
                {">"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FleetDailyReport;
